<template>
  <Teleport to="body">
    <div
      ref="menuRef"
      class="ui-grid-context-menu"
      :style="{ left: `${x}px`, top: `${y}px` }"
    >
      <button
        v-for="item in items"
        :key="item.label"
        type="button"
        class="ui-grid-context-menu__item"
        @click="handleSelect(item)"
      >
        {{ item.label }}
      </button>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import { onClickOutside } from '@vueuse/core'

import { useHotKeys } from '@/plugins/hotKeys'

import { CellContextMenuItem } from '../utils/types'

type Props = {
  x: number
  y: number
  items: CellContextMenuItem[]
}

type Emits = {
  close: []
}

defineProps<Props>()
const emit = defineEmits<Emits>()

defineOptions({
  name: 'GridCellContextMenu',
})

const menuRef = useTemplateRef('menuRef')

const handleSelect = (item: CellContextMenuItem) => {
  item.action()
  emit('close')
}

onClickOutside(menuRef, () => emit('close'))

useHotKeys(
  'escape',
  e => {
    e?.stopPropagation()
    emit('close')
    return true
  },
  { priority: 95 },
)
</script>

<style>
.ui-grid-context-menu {
  @apply fixed z-50;
  @apply flex flex-col;
  @apply min-w-40 p-1;
  @apply bg-body;
  @apply border border-common-border;
  @apply rounded-md shadow-lg;

  &__item {
    @apply flex items-center;
    @apply px-2 py-1.5;
    @apply text-sm sm:text-xs text-left;
    @apply text-gray-700 dark:text-gray-300;
    @apply rounded;
    @apply cursor-pointer;
    @apply hover:bg-body-gray;
  }
}
</style>
